export default "__VITE_ASSET__CQ2Exq3G__"